import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import messages from 'shared/messages/messages';

import {
  selectAll,
  unselectAll
} from 'shared/actions/selectionActions';
import config from 'shared/config/config';
import { FormattedMessage } from 'react-intl';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  container: {
    position: 'fixed',
    zIndex: 9999,
    top: '-105px',
    left: 0,
    right: 0,
    height: '100px',
    padding: '1rem',
    background: config.pwa_selection_bg_color,
    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.5)',
    transition: 'top 0.5s'
  },
  progressBarContainer: {
    position: 'fixed',
    zIndex: 9999,
    top: '100px',
    left: 0,
    right: 0
  },
  overlay: {
    position: 'fixed',
    zIndex: -1000,
    top: 0,
    left: '-100vw',
    bottom: 0,
    width: '100vw',
    background: 'linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7))',
    transition: 'left 0.5s'
  },
  closeIcon: {
    float: 'left',
    marginRight: '0.7rem',
    marginLeft: '-0.2rem',
    color: '#888',
    cursor: 'pointer',
    fontSize: '1.7rem'
  },
  header: {
    float: 'left',
    width: isMobile ? '50vw' : '20vw',
    color: config.pwa_default_font_color
  },
  h1: {
    float: 'left',
    width: '100%',
    fontSize: '1.6rem',
    textAlign: 'left'
  },
  selectAll: {
    float: 'left',
    marginTop: '0.2rem',
    color: config.pwa_default_font_color
  },
  buttons: {
    position: 'absolute',
    top: '1rem',
    right: '1rem'
  },
  button: {
    position: 'relative',
    float: 'right',
    border: '2px solid #000',
    borderRadius: 0,
    background: config.pwa_selection_main_bg_color,
    color: config.pwa_selection_main_font_color,
    padding: '0.5rem 1rem',
    fontSize: '1.2rem',
    cursor: 'pointer',
    marginLeft: '1rem',
    fontFamily: config.sub_font
  },
  secondButton: {
    position: 'relative',
    float: 'right',
    border: '2px solid #000',
    borderRadius: 0,
    background: config.pwa_selection_second_bg_color,
    color: config.pwa_selection_second_font_color,
    padding: '0.5rem 1rem',
    fontSize: '1.2rem',
    cursor: 'pointer',
    marginLeft: '1rem',
    fontFamily: config.sub_font
  }
});

class SelectionHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  onSelectAllChange(event) {
    const { selectAll, unselectAll } = this.props;
    const allSelected = this.getAllSelected();

    if (allSelected) {
      unselectAll();
    } else {
      selectAll();
    }
  }

  getAllSelected() {
    const { selectionItems } = this.props;

    let allSelected = true;
    for (let id in selectionItems) {
      if (!selectionItems[id]) {
        allSelected = false;
        break;
      } 
    }

    return allSelected;
  }

  callback() {
    const allSelected = this.getAllSelected();
    this.props.callback(allSelected);
  }

  render() {
    const {
      classes,
      enabled,
      header,
      buttonText,
      buttonIcon,
      cancel,
      selectionItems
    } = this.props;

    const containerStyle = {};
    const overlayStyle = {};
    const selectAllStyle = {};
    const buttonsStyle = {};

    if (enabled) {
      containerStyle.top = 0;
      overlayStyle.left = 0;

      if (!isMobile) {
        containerStyle.paddingTop = '2rem';
        //selectAllStyle.marginTop = '0.5rem';
      }
    }

    let cancelButton = null;
    if (!isMobile) {
      cancelButton = (
        <button className={classes.secondButton} onClick={cancel}>
          <CloseIcon style={{ marginRight: '0.5rem' }} />
          <span><FormattedMessage {...messages.button_cancel} /></span>
        </button>
      );

      buttonsStyle.top = '1.5rem';
    }

    const allSelected = this.getAllSelected();

    return (
      <div>
        <div className={classes.container} style={containerStyle}>
          <CloseIcon className={classes.closeIcon} onClick={cancel} />
          <div className={classes.header}>
            {/* <h1 className={classes.h1}>{header}</h1> */}
            <div className={classes.selectAll} style={{ display: !isMobile ? 'none' : 'inline', ...selectAllStyle }}>
              <input type="checkbox" style={{ marginRight: '0.5rem', accentColor: config.select_all_enabled }} checked={allSelected} onChange={this.onSelectAllChange.bind(this)} />
              <span style={{ fontSize: '1.2rem', color: config.pwa_selection_font_color }}>
                <FormattedMessage {...messages.consumer_select_all} />
              </span>
            </div>
          </div>
          <div className={classes.selectAll} style={{ display: isMobile ? 'none' : 'inline', ...selectAllStyle }}>
            <input type="checkbox" style={{ marginRight: '0.5rem', color: config.select_all_enabled }} checked={allSelected} onChange={this.onSelectAllChange.bind(this)} />
            <span style={{ fontSize: '1.2rem', color: config.pwa_selection_font_color }}>
              <FormattedMessage {...messages.consumer_select_all} />
            </span>
          </div>
          <div className={classes.buttons} style={buttonsStyle}>
            <button className={classes.button} onClick={this.callback.bind(this)}>
              <span style={{ marginRight: '0.5rem', color: config.pwa_selection_main_font_color }}>
                {buttonIcon}
              </span>
              {buttonText}
            </button>
            {cancelButton}
          </div>
        </div>
        <div className={classes.overlay} style={overlayStyle}></div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  enabled: state.selectionReducer.selection.enabled,
  header: state.selectionReducer.selection.header,
  buttonText: state.selectionReducer.selection.buttonText,
  buttonIcon: state.selectionReducer.selection.buttonIcon,
  callback: state.selectionReducer.selection.callback,
  cancel: state.selectionReducer.selection.cancel,
  selectionItems: state.selectionReducer.selection.items
});

export default connect(mapStateToProps, { selectAll, unselectAll })(withStyles(styles, { withTheme: true })(SelectionHeader));
